import { Box, Button, HStack, Input } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { Text } from '../atoms/Text';

export function Search({ disabled, value = "", onChange = () => {} }: { value?: string, onChange?: (value: string) => void, disabled?: boolean }) {
  return (
    <Box borderRadius={16} bg="white" width={'100%'} boxShadow="4px 4px 10px 0px #0000002E">
      <HStack spacing={2} p={'10px 15px'}>
        {disabled ? (
          <Text align={'start'} fontFamily={'Glory'} flexGrow={1} fontSize={18} color={'#747474'} fontWeight={500}>
            Qual vantagem você quer hoje?
          </Text>
        ) : (
          <Input
            isReadOnly={disabled}
            onClick={(e) => disabled && e.stopPropagation()}
            fontFamily={'Glory'}
            fontSize={18}
            onChange={(e) => onChange(e.target.value)}
            value={value}
            _placeholder={{ color: '#747474' }}
            color={'#747474'}
            fontWeight={500}
            flexGrow={1}
            border={'none'}
            type="text"
            placeholder="Qual vantagem você quer hoje?"
          />
        )}

        <Button padding={0} variant={'plain'}>
          <FiSearch color="#747474" size={25} />
        </Button>
      </HStack>
    </Box>
  );
}
